import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Title,
  Text,
  Input,
  Column,
  Row,
  Button,
  Label,
  UserWarn,
  StyledSelect,
  LicenceErrorMessage,
} from '../../theme/index';
import { Formik } from 'formik';
import {
  signUp,
  localSignUp,
  createJwt,
  CREATE_JWT_SUCCESS,
  USER_SIGNUP_SUCCESS,
  USER_LOCAL_SIGNUP_SUCCESS,
} from './redux/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOptions } from '../../../fixture/data';
import Modal from '../../shared/Modal';
import AddNationalForm from '../../shared/AddNationalForm';
import AddLicenseForm from '../../shared/AddLicenseForm';
import { validation } from '../../../fixture/validation';

const Wrapper = styled.div`
  width: 450px;
  height: 650px;
  background: #fff;
  margin-top: 8em;
  position: relative;
  border-radius: 6px;
  @media (max-width: 400px) {
    width: 350px;
    padding: 2em 0;
  }
  @media (max-width: 320px) {
    width: 320px;
  }
`;

const Form = styled.form`
  width: 100%;
`;

const StyledColumn = styled(Column)`
  width: 85%;
  margin: 0 auto;
  @media (max-width: 400px) {
    width: 90%;
  }
`;

class SignupForm extends Component {
  state = {
    profession: [],
    licenseNumberRequired: true,
    secondeNumberRequired: false,
    isOpen: false,
    type: '',
  };

  handleLicenseNumber = (setFieldValue, values) => {
    this.setState(
      () => {
        return {
          licenseNumberRequired: !this.state.licenseNumberRequired,
        };
      },
      () => {
        if (values.doesNotYetHaveLicenseNumber === 'true') {
          setFieldValue('doesNotYetHaveLicenseNumber', 'false');
        } else {
          setFieldValue('doesNotYetHaveLicenseNumber', 'true');
        }
      }
    );
  };

  toggleModal = type => {
    this.setState(prevState => {
      return {
        type,
        isOpen: !prevState.isOpen,
      };
    });
  };

  handleModalProfession = value => {
    this.setState({
      profession: getOptions('profession', value),
    });
  };

  handleCheckout = () => {
    this.props.history.push({
      pathname: '/login',
      state: { link: `${this.props.checkoutlink}` },
    });
  };

  formatText = str => {
    let result = str.replace(/([A-Z])/g, '-$1');
    return result.charAt(0) + result.slice(1);
  };

  render() {
    const { licenseNumberRequired, isOpen, profession, type } = this.state;
    return (
      <Wrapper style={{ margin: '30px auto', height: 'auto' }}>
        <Title padding=".5em 0 .5em .75em" margin="0">
          Signup
        </Title>
        <Formik
          enableReinitialize
          initialValues={{
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            profession: '',
            state: '',
            license_number: '',
            second_number: '',
            second_state: '',
            second_profession: '',
            national_number: '',
            third_state: '',
            third_profession: '',
            doesNotYetHaveLicenseNumber: 'false',
            national_board: '',
          }}
          validate={values => {
            return validation(values, licenseNumberRequired);
          }}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            let thinkificData = {
              first_name: values.first_name,
              last_name: values.last_name,
              email: values.email,
              password: values.password,
              custom_profile_fields: [
                {
                  value: values.state.value,
                  custom_profile_field_definition_id: 4287,
                },
                {
                  value: values.second_number,
                  custom_profile_field_definition_id: 4286,
                },
                {
                  value: values.license_number,
                  custom_profile_field_definition_id: 8098,
                },
                {
                  value: values.profession.value,
                  custom_profile_field_definition_id: 10282,
                },

                {
                  value: values.second_state.value,
                  custom_profile_field_definition_id: 13665,
                },
                {
                  value: values.second_profession.value,
                  custom_profile_field_definition_id: 13666,
                },
                {
                  value: values.national_number,
                  custom_profile_field_definition_id: 13667,
                },
                {
                  value: values.third_state.value,
                  custom_profile_field_definition_id: 13668,
                },
                {
                  value: values.third_profession.value,
                  custom_profile_field_definition_id: 13669,
                },
                {
                  value: values.doesNotYetHaveLicenseNumber,
                  custom_profile_field_definition_id: 13664,
                },
                {
                  value: values.national_board.value,
                  custom_profile_field_definition_id: 13670,
                },
              ],
              send_welcome_email: true,
            };

            let localData = {
              first_name: values.first_name,
              last_name: values.last_name,
              email: values.email,
              password: values.password,
              custom_profile_fields: [
                {
                  value: values.state.value,
                  custom_profile_field_definition_id: 4287,
                },
                {
                  value: values.second_number,
                  custom_profile_field_definition_id: 4286,
                },
                {
                  value: values.license_number,
                  custom_profile_field_definition_id: 8098,
                },
                {
                  value: values.profession.value,
                  custom_profile_field_definition_id: 10282,
                },
                {
                  value: values.national_number,
                },
              ],
              send_welcome_email: true,
            };

            // let state = values.state.value.replace(/\s+/g, '-');
            // let profession = values.profession.value.replace(/\s+/g, '-');
            let state = values.state.value
              .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
              .replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);

            let profession = values.profession.value
              .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
              .replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);
            if (this.props.checkoutlink) {
              this.props.localSignUp(localData).then(action => {
                if (action.type === USER_LOCAL_SIGNUP_SUCCESS) {
                  this.props.signUp(thinkificData).then(action => {
                    if (action.type === USER_SIGNUP_SUCCESS) {
                      this.props.createJwt(localData).then(action => {
                        let url = this.props.checkoutlink;
                        url = url.split('.')[1] + '.' + url.split('.')[2];
                        window.location.href = `https://achievece.thinkific.com/api/sso/v2/sso/jwt?jwt=${
                          action.data
                        }&return_to=https://learn.${url}`;
                      });
                    } else {
                      if (action.response.data) {
                        setErrors({
                          thinkificError: `Email already exists`,
                        });
                      }
                    }
                  });
                } else {
                  setErrors({
                    thinkificError: action.response.data,
                  });
                }
              });
            } else {
              this.props.localSignUp(localData).then(action => {
                if (action.type === USER_LOCAL_SIGNUP_SUCCESS) {
                  this.props.signUp(thinkificData).then(action => {
                    if (action.type === USER_SIGNUP_SUCCESS) {
                      this.props.createJwt(localData).then(action => {
                        if (action.type === CREATE_JWT_SUCCESS) {
                          localStorage.setItem('authorization', action.data);
                          window.location.href = `https://achievece.thinkific.com/api/sso/v2/sso/jwt?jwt=${
                            action.data
                          }&return_to=https://www.achievece.com/${this.formatText(
                            profession.trim()
                          )}/${state.trim()}`;
                        }
                      });
                    } else {
                      if (action.response.data) {
                        // let keysArr = Object.keys(action.response.data.errors);
                        // let valuesArr = Object.values(action.response.data.errors);
                        setErrors({
                          thinkificError: `Email already exists`,
                          // thinkificError: keysArr[0] + ' ' + valuesArr[0],
                        });
                      }
                    }
                  });
                } else {
                  setErrors({
                    thinkificError: action.response.data,
                  });
                }
              });
            }
          }}
          render={({
            values,
            handleBlur,
            handleChange,
            errors,
            touched,
            setFieldValue,
            handleSubmit,
          }) => {
            const renderLicenseError = (errors = []) => {
              const errorList = errors.map((error, index) => (
                <li key={index}>{error}</li>
              ));
              return (
                <LicenceErrorMessage>
                  <span>Please adjust:</span>
                  <ul>{errorList}</ul>
                </LicenceErrorMessage>
              );
            };

            return (
              <Form
                onSubmit={handleSubmit}
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                }}
              >
                <StyledColumn style={{ paddingBottom: '30px' }}>
                  <Row
                    alignitems="center"
                    style={{ position: 'relative', zIndex: '10000' }}
                  >
                    {errors.thinkificError && errors.thinkificError && (
                      <Text error>{errors.thinkificError}</Text>
                    )}
                  </Row>
                  <Column width="100%" margin="0 auto">
                    <Row
                      margin=".1em 0"
                      alignitems="center"
                      style={{ position: 'relative' }}
                    >
                      <Label
                        htmlFor="first_name"
                        style={{ position: 'relative', marginRight: '1em' }}
                      >
                        First name *
                        {touched.first_name && errors.first_name && (
                          <UserWarn top="-6px">
                            <Text error>{errors.first_name}</Text>
                          </UserWarn>
                        )}
                        <Input
                          id="first_name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.first_name}
                          loginSmall
                          bordererror={
                            touched.first_name &&
                            errors.first_name &&
                            '1px solid red'
                          }
                        />
                      </Label>
                      <Label htmlFor="last_name">
                        Last name *
                        {touched.last_name && errors.last_name && (
                          <UserWarn top="-6px">
                            <Text error>{errors.last_name}</Text>
                          </UserWarn>
                        )}
                        <Input
                          type="last_name"
                          id="last_name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.last_name}
                          loginSmall
                          bordererror={
                            touched.last_name &&
                            errors.last_name &&
                            '1px solid red'
                          }
                        />
                      </Label>
                    </Row>
                    <Row
                      margin=".1em 0"
                      alignitems="center"
                      style={{ position: 'relative' }}
                    >
                      <Label htmlFor="email">
                        Email *
                        {touched.email && errors.email && (
                          <UserWarn top="-6px">
                            <Text error>{errors.email}</Text>
                          </UserWarn>
                        )}
                        <Input
                          id="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          login
                          bordererror={
                            (errors.thinkificError && '1px solid red') ||
                            (touched.email && errors.email && '1px solid red')
                          }
                        />
                      </Label>
                    </Row>
                    <Row
                      margin=".1em 0"
                      alignitems="center"
                      style={{ position: 'relative' }}
                    >
                      <Label htmlFor="password">
                        Password *
                        {touched.password && errors.password && (
                          <UserWarn top="-6px">
                            <Text error>{errors.password}</Text>
                          </UserWarn>
                        )}
                        <Input
                          type="password"
                          id="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                          bordererror={
                            touched.password &&
                            errors.password &&
                            '1px solid red'
                          }
                          login
                        />
                      </Label>
                    </Row>
                    <Row
                      margin=".1em 0"
                      alignitems="center"
                      style={{ position: 'relative' }}
                    >
                      <Label htmlFor="state">
                        State *
                        {touched.state && errors.state && (
                          <UserWarn top="-6px">
                            <Text error>{errors.state}</Text>
                          </UserWarn>
                        )}
                        <StyledSelect
                          type="state"
                          form
                          id="state"
                          options={getOptions('state')}
                          onChange={value => {
                            setFieldValue('state', value);
                            this.setState({
                              profession: getOptions('profession', value),
                            });
                          }}
                          onBlur={handleBlur}
                          value={values.state}
                        />
                      </Label>
                      <Label htmlFor="profession">
                        Profession *
                        {touched.profession && errors.profession && (
                          <UserWarn top="-6px">
                            <Text error>{errors.profession}</Text>
                          </UserWarn>
                        )}
                        <StyledSelect
                          type="profession"
                          form
                          id="profession"
                          options={this.state.profession}
                          onChange={value => {
                            setFieldValue('profession', value);
                          }}
                          onBlur={handleBlur}
                          value={values.profession}
                        />
                      </Label>
                    </Row>
                    {licenseNumberRequired && (
                      <Row
                        margin=".1em 0"
                        alignitems="center"
                        style={{ position: 'relative' }}
                      >
                        <Label htmlFor="license_number">
                          License # *
                          {touched.license_number &&
                            errors.license_number_arr &&
                            errors.license_number_arr.length > 0 &&
                            renderLicenseError(errors.license_number_arr)}
                          <Input
                            id="license_number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.license_number}
                            login
                            required={licenseNumberRequired}
                            bordererror={
                              touched.license_number &&
                              errors.license_number_arr &&
                              errors.license_number_arr.length > 0 &&
                              '1px solid red'
                            }
                          />
                        </Label>
                      </Row>
                    )}
                    <Row
                      margin=".25em 0"
                      alignitems="center"
                      style={{ position: 'relative' }}
                    >
                      <Label>
                        <input
                          onClick={() =>
                            this.handleLicenseNumber(setFieldValue, values)
                          }
                          type="checkbox"
                          name="licenseNumber"
                          value="licenseNumber"
                          style={{ margin: '.25em' }}
                        />
                        I do not yet have a license #
                      </Label>
                    </Row>
                    <Row
                      margin=".25em 0"
                      alignitems="center"
                      justifycontent="space-between"
                      style={{ position: 'relative' }}
                    >
                      {values.second_number && (
                        <a onClick={() => this.toggleModal('second')}>
                          <Label add>
                            Second number: {values.second_number}
                          </Label>
                        </a>
                      )}
                      {!values.second_number && (
                        <a onClick={() => this.toggleModal('second')}>
                          <Label add>Add a second license number</Label>
                        </a>
                      )}

                      <Label loginButton onClick={this.handleCheckout}>
                        Have an account?
                      </Label>
                    </Row>

                    {values.national_number && (
                      <a onClick={() => this.toggleModal('third')}>
                        <Label add>
                          National number: {values.national_number}
                        </Label>
                      </a>
                    )}
                    {!values.national_number && (
                      <a onClick={() => this.toggleModal('third')}>
                        <Label add>Add a national license number</Label>
                      </a>
                    )}
                  </Column>
                  <Modal
                    show={isOpen}
                    togglemodal={this.toggleModal}
                    height="auto"
                  >
                    {type === 'second' && (
                      <AddLicenseForm
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        profession={profession}
                        setFieldValue={setFieldValue}
                        togglemodal={this.toggleModal}
                        values={values}
                        touched={touched}
                        errors={errors}
                      />
                    )}

                    {type === 'third' && (
                      <AddNationalForm
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        profession={profession}
                        setFieldValue={setFieldValue}
                        togglemodal={this.toggleModal}
                        values={values}
                        touched={touched}
                        errors={errors}
                      />
                    )}
                  </Modal>
                  <Button login type="submit" style={{ marginTop: '1.5em' }}>
                    Sign up
                  </Button>
                </StyledColumn>
              </Form>
            );
          }}
        />
      </Wrapper>
    );
  }
}

export default withRouter(
  connect(
    null,
    { signUp, localSignUp, createJwt }
  )(SignupForm)
);



// WEBPACK FOOTER //
// ./src/components/screens/Signup/SignupForm.jsx